module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), (_vm.quiz) ? _c('div', {
    staticClass: "col-xs-12 mt-30 mb-30"
  }, [_c('div', {
    staticClass: "portlet light portlet-fit portlet-form bordered col-xs-12 p-0 "
  }, [_c('div', {
    staticClass: "portlet-title col-xs-12 "
  }, [_c('div', {
    staticClass: "caption tabbable-line p-0"
  }, [_c('ul', {
    staticClass: "nav nav-tabs "
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "false"
    },
    on: {
      "click": function($event) {
        _vm.show.table = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-layers"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Tableau ")])])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "aria-expanded": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.report = true
      }
    }
  }, [_c('i', {
    staticClass: " icon-note"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold uppercase"
  }, [_vm._v("Rapport")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body col-xs-12 mb-30"
  }, [_c('list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.table),
      expression: "show.table"
    }],
    staticClass: "mt-30",
    attrs: {
      "columns": _vm.columns,
      "dataSet": _vm.dataSet
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.report),
      expression: "show.report"
    }],
    staticClass: "col-xs-12"
  }, [_c('report-preconization', {
    attrs: {
      "preconizations": _vm.preconizations
    },
    on: {
      "update:preconizations": function($event) {
        _vm.preconizations = $event
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-circle default mt-20 ml-10",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n             Retour\n          ")])], 1)])]) : _c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-md-12 page-404 mt-50 pb-50"
  }, [_c('div', {
    staticClass: "number font-green"
  }, [_vm._v(" 404 ")]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('h3', [_vm._v("Oops ! Questionnaire non trouvé.")]), _vm._v(" "), _c('p', [_vm._v(" Nous n'avons pas réussi à trouver ce questionnaire.\n                "), _c('br'), _vm._v("\n                Vérifiez'url et tentez de recharger la page.\n            ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h2', [_vm._v("Etude du Web Français Bdx : Synthèse des préconisations ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9fcdb14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/quizzes/preconizations/show_actions.vue
// module id = 122
// module chunks = 0